import React from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const DateInputsPopover = ({
  onCountChange = undefined,
  customNameGte = undefined,
  customNameLt = undefined,
  customTitle = undefined,
}) => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();

  const gteName = customNameGte ?? 'create_time__gte';
  const ltName = customNameLt ?? 'create_time__lt';

  const [gte, lt] = useWatch({ name: [gteName, ltName] });
  const filterCount = [gte, lt]
    .filter((arr) => Array.isArray(arr) && arr.length > 0)
    .length > 0 ? 1 : 0;
  useFilterCount('date', filterCount, onCountChange);

  const handleReset = () => {
    setValue(gteName, null);
    setValue(ltName, null);
  };
  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="dateFilter"
      triggerValue={customTitle ?? t('event_date')}
    >
      <Control.DateInput
        control={control}
        data-testid='create_time__gte'
        enableTime
        id={gteName}
        isClearable
        label={t('from_label')}
        name={gteName}
        onClear={() => setValue(gteName, null)}
        options={START_OF_DAY}
      />
      <Divider small />
      <Control.DateInput
        control={control}
        data-testid='create_time__lt'
        enableTime
        id={ltName}
        isClearable
        label={t('to_label')}
        name={ltName}
        onClear={() => setValue(ltName, null)}
        options={END_OF_DAY}
      />
      <Divider small />
      <Control.Button
        disabled={filterCount === 0}
        kind="negative"
        onClick={handleReset}
        size="small"
        variant="filled"
      >
        {t('button.clear')}
      </Control.Button>
    </CustomFilterPopover>
  );
};
